// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__L30nY","disabled":"FileBtn_disabled__1OVCa","warn":"FileBtn_warn__3NK8a","fade":"FileBtn_fade__3h4jn"};